import {ICartLineItem} from '../../i';

// The five product ids whose line never carries the badge, flagged or not (as the cart line has always had it).
const noBadgeProductIds = [24715, 24716, 24717, 67336, 67337];

/** True when a cart line shows the "Fast shipping" badge: the cart step and the redesign's order summary agree on it. */
export function showsFastShippingBadge(o: Pick<ICartLineItem, 'is_fast_shipping' | 'productId'>, isMyFrames: boolean): boolean {
    return !isMyFrames && !!o.is_fast_shipping && !noBadgeProductIds.includes(o.productId);
}
